import React, {useCallback, useContext, useState} from 'react';
import {Popup, Input, toast, setOptions, Button} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/dashboardItemsRename.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import Loading from "../utils/Loading";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardItemsRename({locale, dialog, Dialog, width, myItem, setMyItem}) {
    const {wsCall} = useContext(NetworkContext);
    const [name, setName] = useState(myItem.name);
    const [saving, setSaving] = useState(false);

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const ButtonSave = () => {
        if (!name) {
            toast({message: locale.dashboardItemsRename.c, color: 'danger', display: 'bottom', duration: 3000});
        } else if (name) {
            setSaving(true);

            const message = {
                type: 'wss',
                path: 'item-name',
                action: 'update',
                data: {
                    item: myItem.id,
                    name: name
                }
            };
            wsCall(message);
        }
    }

    const ButtonClose = () => {
        setMyItem({});
        Dialog({view: 'dashboardWorkspace', tab: 'items'});
    }

    return (
        <Popup className="cs-dashboard-items-rename-popup" width={600} display="center" scrollLock={true} closeOnOverlayClick={false} closeOnEsc={false} buttons={[]} isOpen={dialog.view === 'dashboardItemsRename'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-items-rename-header-col">
                <div className="mbsc-row cs-dashboard-items-rename-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-items-rename-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-items-rename-header-col mbsc-align-center" : "mbsc-col cs-dashboard-items-rename-header-col"} >
                        <Button className="cs-dashboard-items-rename-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {locale.dashboardItemsRename.e}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-items-rename-header-col mbsc-align-right">
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-items-rename-close-button" onClick={() => ButtonClose()} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-items-rename-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            {!saving &&
                <Input disabled={saving} inputStyle="underline" label={locale.dashboardItemsRename.b} labelStyle="floating" type="text" name="account" value={name} onChange={ev => setName(ev.target.value)} />
            }
            {saving &&
                <Loading />
            }
            {!saving &&
                <div className="mbsc-button-group-justified cs-dashboard-items-rename-nav-buttons">
                    <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-items-rename-nav-button" onClick={() => ButtonSave()} >
                        {locale.dashboardItemsRename.a}
                    </Button>
                </div>
            }
        </Popup>
    );
}

export default DashboardItemsRename;
